export let angularProjects = [
    {
        title: "Coffee Tracker",
        link: "https://github.com/VocalNight/Coffee_Tracker_Angular",
        description: "A small tracker, using tailwind with Angular for practice."
    },
    {
        title: "Sleep Tracker",
        link: "https://github.com/VocalNight/SleepTracker",
        description: "A tracker using Angular material."
    },
    {   
        title: "Brewery Project",
        link: "https://github.com/VocalNight/CodeReviews.Challenges.BreweryAPI",
        description: "A crud simulating a small brewery system."
    
    }
]
